import api from '../httpClient';
import {
  ListAdminFeedbackParams,
  ListAdminFeedbackResponse,
  SubmitFeedbackRequest,
  SubmitFeedbackResponse,
} from '@/types/feedback';

/**
 * Submit structured feedback for the application, client details, or meal plans.
 */
export const submitFeedback = async (
  payload: SubmitFeedbackRequest,
): Promise<SubmitFeedbackResponse> => {
  const response = await api.post('/feedback', payload);
  return response.data;
};

const toFeedbackQueryParams = (params: ListAdminFeedbackParams = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    query.set(key, String(value));
  });

  return query;
};

export const listAdminFeedback = async (
  params: ListAdminFeedbackParams = {},
): Promise<ListAdminFeedbackResponse> => {
  const response = await api.get('/feedback', {
    params: Object.fromEntries(toFeedbackQueryParams(params)),
  });
  return response.data;
};

export const exportAdminFeedback = async (
  params: ListAdminFeedbackParams = {},
): Promise<{ blob: Blob; filename: string }> => {
  const response = await api.get('/feedback/export', {
    params: Object.fromEntries(toFeedbackQueryParams(params)),
    responseType: 'blob',
  });

  const disposition = response.headers['content-disposition'] || '';
  const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);

  return {
    blob: response.data,
    filename: filenameMatch?.[1] || 'nutritionist-feedback.csv',
  };
};
